export const appMixin = {
  data() {
    return {
      debugToken: '1e41ee5575df75c3ed53c5fa0f8dc7ae',
      debugAppId: '1692d9cb170b471093e4922d67402264'
    }
  },
}